import useLoginAuth from "./useLoginAuth";
import { PromiseState } from "@/constants";
import { namespace, StoreContext } from "@/context";
import { useContext, useEffect, useState } from "react";

export default function useCheckLoginState () {
  const { state } = useContext(StoreContext);
  const { account } = state[namespace.app];
  const { isLogin } = useLoginAuth(account);

  const [isLogout, setIsLogout] = useState<boolean | null>(null);
  // 真正获取到登录状态的标识
  const [hadLoginState, setHadLoginState ] = useState(false);

  useEffect(() => {
    // 只有停止了请求，才能确认真正的登录状态
    if (!isLogin && hadLoginState) {
      setIsLogout(true);
    } else {
      setIsLogout(false);
    }
  }, [isLogin, hadLoginState]);

  useEffect(() => {
    if (account && account?.status !== PromiseState.PENDING) {
      setHadLoginState(true);
    }
  }, [account]);

  return { isLogout, account, hadLoginState };

}